import { render, staticRenderFns } from "./MallConfirm.vue?vue&type=template&id=c5801f6e&scoped=true"
import script from "./MallConfirm.vue?vue&type=script&lang=js"
export * from "./MallConfirm.vue?vue&type=script&lang=js"
import style0 from "./MallConfirm.vue?vue&type=style&index=0&id=c5801f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5801f6e",
  null
  
)

export default component.exports